const API_BASE_URL = "https://ipmapi.intbull.com";
const API_PREFIX = "/v1";
const ANALYTICS_API_PREFIX = `${API_PREFIX}/analytics`;

const normalizePath = (path) => (path.startsWith("/") ? path : `/${path}`);

export const apiUrl = (path) => `${API_BASE_URL}${normalizePath(path)}`;

export const analyticsUrl = (path) =>
  `${API_BASE_URL}${ANALYTICS_API_PREFIX}${normalizePath(path)}`;

export { API_BASE_URL, API_PREFIX, ANALYTICS_API_PREFIX };
